<template>
  <div class="meeting">
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="meetingList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="hy-list" v-if="loading || meetingList.length > 0">
        <XshyItem
          class="hy-list-item"
          v-for="item in meetingList"
          :key="item.id"
          :title="item.title"
          :cover="item.cover"
          :beginTime="
            item.beginTime.slice(0, 10).replace(RegExp('-', 'g'), '.')
          "
          :address="item.province + '-' + item.city"
          @click.native="toMeetingDetails(item.id, item.goodsId, item.open)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>

<script>
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "meeting",
  components: {
    XshyItem,
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      curPage: 1,
      meetingList: [],
    };
  },
  methods: {
    // 获取收藏列表
    async getUserCollectMeetingList() {
      this.loading = true;
      const resp = await this.$apis.userServe.getUserCollectMeetingList({
        pageSize: 5,
        pageNo: this.curPage,
      });
      if (resp.resultCode == 200) {
        this.meetingList = resp.data.list;
        this.finished = resp.data.list.length < 20 ? true : false;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    onLoad() {
      if (sessionStorage.getItem("token")) {
        this.getUserCollectMeetingList();
      } else {
        this.finished = true;
        Toast("请先登录");
      }
    },
    toMeetingDetails(id, goodsId, open) {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
            open ? "&open=" + open : ""
          }`,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting {
  width: 100%;
  height: 100%;
  .hy-list {
    .hy-list-item {
      margin: 12px auto;
      padding-bottom: 15px;
      width: 351px;
      // height: 275px;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
    }
  }
}
</style>
